import React, { CSSProperties } from "react";

// Rotates ▶️ or ▼ based on expanded state
export function StateInspectorArrow({
  expanded,
  onClick,
  style,
}: {
  expanded: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}) {
  return (
    <span
      role="button"
      onClick={onClick}
      style={{
        display: "inline-block",
        textAlign: "center",
        transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
        fontFamily: "Menlo, monospace",
        ...style,
      }}
    >
      {"▼"}
    </span>
  );
}
